import React, { useState } from 'react'
import { Text } from 'rebass'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { BodyTitle } from '../../components/bakery/styleds'
import FarmCards from './components/FarmCards'
import { MINTTOKEN } from '../../constants/bakery'
import { useWalletModalToggle } from '../../state/application/hooks'
import { useActiveWeb3React } from '../../hooks'
import { ButtonPrimary } from '../../components/Button'

const BodyHead = styled.div`
  color: ${({theme}) => theme.bsText3};
  text-align: center;
  margin-bottom: 16px;
`
const TipsBox = styled.div`
  width: 892px;
  background-color:  ${({ theme }) => theme.bg1 };
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 32px;
  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 90%;
  `};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 300px;
  `};
`
const TipsRow = styled.div`
  margin-top: 20px;
`
const TipsTitle = styled(Text)`
  font-family: Baloo Da;
  color: ${({ theme }) => theme.bsText7};
`
const activeClassName = 'ACTIVE'
const TipsAnswer = styled.div.attrs({activeClassName})`
  font-family: Yuanti SC;
  color: ${({ theme }) => theme.bsText3 };
  font-size: 14px;
  line-height: 22px;
  &.${activeClassName} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
const LoginBtn = styled(ButtonPrimary)`
  margin: 54px auto 0;
  width: initial;
  padding: 8px 16px;
`
const IconUp = styled.img`
  margin-left: 10px;
`
const IconDown = styled.img`
  margin-left: 10px;
`
const Info = styled.div`
`
const Bold = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.bsText7 };
`
const LoginBtnWrapper = styled.div``
export default function MyEggs () {
  const curTab = MINTTOKEN.AETHANDETH2
  const { active, account } = useActiveWeb3React()
  const { t } = useTranslation()
  const toggleWalletModal = useWalletModalToggle()
  const [row1, setRow1] = useState(true)
  const [row2, setRow2] = useState(true)
  const [row3, setRow3] = useState(true)
    return (
    <>
      {!(active && account) ?
        (
          <LoginBtnWrapper>
            <LoginBtn onClick={toggleWalletModal}>{t('Connect to a wallet')}</LoginBtn>
          </LoginBtnWrapper>
        )
        : <>
          <BodyHead>
            <BodyTitle fontSize={32} fontWeight={700}>
              ETH2.0
            </BodyTitle>
          </BodyHead>
          <TipsBox>
              <TipsTitle>
                What is ETH 2.0?
                { !row1 && <IconDown onClick={() => setRow1(true)} src="/images/bakery/icon_up.svg"></IconDown>}
                { row1 && <IconUp onClick={() => setRow1(false)} src="/images/bakery/icon_down.svg"></IconUp>}
              </TipsTitle>
              <TipsAnswer className={row1 ? activeClassName : ''}>ETH 2.0 is the next generation of Ethereum and uses proof-of-stake (PoS) to secure its network. PoS can generate staking income but participating in ETH2.0 requires 32 ETH in staking and validator construction technology.</TipsAnswer>
            <TipsRow>
              <TipsTitle>What is ETH2.0 staking token?
                { !row2 && <IconDown onClick={() => setRow2(true)} src="/images/bakery/icon_up.svg"></IconDown>}
                { row2 && <IconUp onClick={() => setRow2(false)} src="/images/bakery/icon_down.svg"></IconUp>}
              </TipsTitle>
              <TipsAnswer className={row2 ? activeClassName : ''}>
                {
                  row2 ? (
                    <Info>ETH2.0 staking token is an ETH-anchored asset issued by ETH2.0 and ETH2.0 commissioned mining institutions...</Info>
                  ) : 
                    <>
                      <Info>ETH2.0 staking token is an ETH-anchored asset issued by ETH2.0 and ETH2.0 commissioned mining institutions.</Info>
                      <Info style={{marginTop: 30}}>For example, BETH is an ETH2.0 staking token issued by Binance on BSC and Ethereum. So users can stake their ETH in a 1:1 ratio to get BETH.<br/> aETH is a synthetic derivative asset issued by Ankr Staking that enables instant liquidity for the Ethereum 2.0 network. aETH represents the staked ETH plus all future staking rewards.</Info>
                    </>
                }
              </TipsAnswer>
            </TipsRow>
            <TipsRow>
              <TipsTitle>Why should you stake your BETH-pair LP tokens here?
                { !row3 && <IconDown onClick={() => setRow3(true)} src="/images/bakery/icon_up.svg"></IconDown>}
                { row3 && <IconUp onClick={() => setRow3(false)} src="/images/bakery/icon_down.svg"></IconUp>}
              </TipsTitle>
              <TipsAnswer className={row3 ? activeClassName : ''}>
                {
                  row3 ? (
                    <Info>You will benefit from BakerySwap's ETH2.0 liquidity farming if you stake your LP tokens on BakerySwap...</Info>
                  ) : <>
                    <Info>You will benefit from BakerySwap's ETH2.0 liquidity farming if you stake your LP tokens on BakerySwap:</Info>
                    <Info>1. <Bold>ETH2.0 staking token</Bold> is easily accessible and tradable on BakerySwap and providing much higher returns than the basic returns of staking.</Info>
                    <Info>2.There will be no minimum 32 $ETH needed on BSC, stake $ETH at Binance to obtain 
                    <Bold>ETH2.0 staking token</Bold>, and you may join as much as you want to put in. 100% of the POS rewards on Ethereum chain will be returned to you. There is no need to take the risk of being a block producer.</Info>
                    <Info>3. <Bold>ETH2.0 staking token</Bold> can be traded on BakerySwap at any time, and the rewards can be harvested at any time, without a long lock-up period.</Info>
                    <Info>4. Providing some of these liquidities will get extra $BAKE rewards provided by BakerySwap, which are exclusive on BakerySwap.</Info>
                  </>
                }
              </TipsAnswer>
            </TipsRow>
          </TipsBox>
          <FarmCards tokenName={curTab}/>
      </>
      }
    </>
  )
}